const banks = {
  ALANDSBANKEN: 'alandsbanken',
  DANSKE_BANK: 'danske-bank',
  HANDELSBANKEN: 'handelsbanken',
  ICA: 'ica',
  LANSFORSAKRINGAR: 'lansforsakringar',
  NORDEA: 'nordea',
  SEB: 'seb',
  SKANDIA: 'skandia',
  SPARBANKEN_SYD: 'sparbanken-syd',
  SPARBANKERNA: 'sparbankerna',
  SWEDBANK: 'swedbank',
};

export default banks;
